/**
 * 网点出发
 * @startDate
 * @endDate
 * @scanSite
 * @type
*/
export const SiteDepartQuery = (params) => {
  return [
    {
      // 网点出发量
      dataSource: 'actual_load_unload_result',
      dimensions: ['scanSite'],
      // simpleGranularity: params.type || 'day',
      // simpleGranularity: 'day',
      startDate: params.startDate,
      endDate: params.endDate,
      andFilters: [
        {key: 'scanType', value: '分拨装车'},
        {key: 'isOriginCenter', value: '是'},
        {key: 'scanSite', value: params.scanSite},
      ],
      durationGranularity: {
        duration: '86400000',
        origin: params.startDate
      }
    },
    {
      // 网点明细表
      simpleGranularity: 'all',
      dataSource: 'actual_load_unload_result',
      dimensions: ['originSite'],
      startDate: params.startDate,
      endDate: params.endDate,
      andFilters: [
        {key: 'scanType', value: '分拨装车'},
        {key: 'isOriginCenter', value: '是'},
        {key: 'scanSite', value: params.scanSite},
      ]
    }
  ]
}